import React from "react";
import { Box, Button, Stack, useTheme } from "@mui/joy";
import { useMediaQuery } from "@mui/material";
import { useApplicants } from "context/ApplicantsContext";
import { FilterList } from "@mui/icons-material";

interface MeetCandidatesButtonProps {
  onClick: () => void;
  setFilterModalOpen: (open: boolean) => void;
}

const MeetCandidatesButton: React.FC<MeetCandidatesButtonProps> = ({ onClick, setFilterModalOpen }) => {
  const { selectedApplicantIds } = useApplicants();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const getButtonText = () => {
    if (selectedApplicantIds.length === 0) {
      return 'Select People';
    }
    return `Meet ${selectedApplicantIds.length} ${selectedApplicantIds.length !== 1 ? 'People' : 'Person'}`;
  };
  
  return(
    <Stack
      direction="row"
      spacing={2}
      sx={{
        display: {xs: 'flex', sm: selectedApplicantIds.length > 0 ? 'flex' : 'none'},
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        borderRadius: '12px',
        p: 2,
        mb: {xs: 0, md: 2},
        maxWidth: 'sm',
        mx: 'auto'
      }}
    >
      {isMobile && (
        <Button 
          variant="plain" 
          size="sm"
          sx={{
            flexGrow: 0,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
            },
            height: 56,
            fontSize: '18px',
            fontWeight: 600,
            borderRadius: '12px',
          }}
          onClick={() => setFilterModalOpen(true)}
        >
          <FilterList />
        </Button>
      )}
      <Button
        variant="solid"
        size="lg"
        onClick={onClick}
        disabled={selectedApplicantIds.length === 0}
        sx={{
          flexGrow: 1,
          backgroundColor: selectedApplicantIds.length === 0 ? '#7B7F85' : '#2e2d7e',
          '&:hover': {
            backgroundColor: selectedApplicantIds.length === 0 ? '#7B7F85' : '#23225f',
          },
          '&:disabled': {
            backgroundColor: '#7B7F85',
            color: 'rgba(255, 255, 255, 0.6)',
            cursor: 'not-allowed',
          },
          height: 56,
          fontSize: '18px',
          fontWeight: 600,
          borderRadius: '12px',
        }}
      >
        {getButtonText()}
      </Button>
    </Stack>
  );
}

export default MeetCandidatesButton; 